/* Modalco CRO katmanı (2026-10-06). Geri alma: theme.liquid'deki modalco-cro satırlarını silin. */
/* Yüzen butonlar (2026-10-13): Modalco Club, Fırsatlar ve Güzellik danışmanı yalnızca ana sayfanın en üstünde yazılı görünür, kaydırınca ikon olur; diğer tüm sayfalarda her zaman ikondur (dokununca açılır). Butonlar oluşmadan önce sınıf konsun diye dosyanın başında durur. Geri alma: bu bloğu ve modalco-cro.css'teki "9) Yüzen butonlar" kurallarını silin. */
(function () {
  var b = document.body,
    on = false,
    rq = 0;
  if (!b) return;
  if (location.pathname.replace(/^\/en(\/|$)/, "/") !== "/") {
    b.classList.add("mc-fab-mini");
    return;
  }
  function upd() {
    rq = 0;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0,
      m = on ? y > 8 : y > 60;
    if (m !== on) {
      on = m;
      b.classList.toggle("mc-fab-mini", m);
    }
  }
  window.addEventListener(
    "scroll",
    function () {
      if (!rq) rq = requestAnimationFrame(upd);
    },
    { passive: true },
  );
  upd();
})();
(function () {
  var d = document,
    w = window,
    root = d.documentElement;
  var EN = (root.lang || "").toLowerCase().indexOf("en") === 0;
  var R = (w.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function U(p) {
    return R.replace(/\/$/, "") + p;
  }
  function T(tr, en) {
    return EN ? en : tr;
  }
  function ls(k, v) {
    try {
      if (v === void 0) return localStorage.getItem(k);
      localStorage.setItem(k, v);
    } catch (e) {
      return null;
    }
  }
  function money(c) {
    return (
      (c / 100).toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " TL"
    );
  }
  var path = location.pathname.replace(/^\/en(\/|$)/, "/");

  /* ---------- Anında sepete ekleme geri bildirimi ----------
     Shopify'ın ekleme isteği ~1 sn sürüyor. Bildirim penceresi tıklar tıklamaz "Sepete ekleniyor…"
     olarak açılır, sepet sayısı hemen artar; Shopify onaylayınca gerçek içerik gelir.
     Hata olursa pencere kapanır ve sayı geri alınır. */
  var OA = null;
  function esc(t) {
    return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function patchCN(cn) {
    if (cn.__mcOA) return;
    cn.__mcOA = 1;
    var o = cn.renderContents;
    if (typeof o === "function")
      cn.renderContents = function () {
        var r = o.apply(this, arguments);
        if (OA) OA.done();
        return r;
      };
  }
  function hookErr() {
    if (hookErr.on) return;
    var E =
        (typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS) ||
        w.PUB_SUB_EVENTS,
      S = (typeof subscribe === "function" && subscribe) || w.subscribe;
    if (!E || !E.cartError || typeof S !== "function") return;
    hookErr.on = 1;
    try {
      S(E.cartError, function () {
        OA && OA.fail();
      });
    } catch (e) {}
  }
  function optimisticAdd(info) {
    var cn = d.querySelector("cart-notification"),
      box = d.getElementById("cart-notification");
    if (!cn || !box || typeof cn.open !== "function") return null;
    patchCN(cn);
    hookErr();
    if (OA) OA.cancel();
    var head = box.querySelector(".cart-notification__heading"),
      prod = d.getElementById("cart-notification-product"),
      h0 = head ? (box.__mcH0 = box.__mcH0 || head.innerHTML) : "";
    if (head) head.innerHTML = h0;
    if (prod && info && info.title) {
      prod.innerHTML =
        (info.img
          ? '<div class="cart-notification-product__image global-media-settings"><img src="' +
            esc(info.img) +
            '" alt="" width="70" height="70" loading="eager" style="object-fit:contain"></div>'
          : "") +
        '<div><h3 class="cart-notification-product__name h4">' +
        esc(info.title) +
        "</h3>" +
        (info.price
          ? '<dl><div class="product-option"><dd>' +
            (info.qty > 1 ? info.qty + " × " : "") +
            esc(info.price) +
            "</dd></div></dl>"
          : "") +
        "</div>";
    }
    box.classList.add("mc-oa", "mc-lad-pend");
    var bub = d.querySelector(
        "#cart-icon-bubble .cart-count-bubble span[aria-hidden]",
      ),
      b0 = bub ? bub.textContent : null;
    if (bub && info && info.qty && info.qty <= 20)
      bub.textContent = (parseInt(b0, 10) || 0) + info.qty;
    try {
      var hd = d.querySelector("sticky-header");
      hd && hd.reveal && hd.reveal();
    } catch (e) {}
    try {
      var dv = cn.dispatchCartViewEvent;
      cn.dispatchCartViewEvent = function () {};
      try {
        cn.open();
      } finally {
        cn.dispatchCartViewEvent = dv;
      }
    } catch (e) {}
    var h = {},
      tm = setTimeout(function () {
        h.fail();
      }, 12000);
    function restore() {
      clearTimeout(tm);
      if (head) head.innerHTML = h0;
      box.classList.remove("mc-oa");
    }
    h.done = function () {
      if (OA !== h) return;
      OA = null;
      restore();
      try {
        var pb = d.getElementById("cart-notification-product"),
          nm = pb && pb.querySelector(".cart-notification-product__name");
        if (nm && info && info.price && !pb.querySelector(".mc-cn-price"))
          nm.insertAdjacentHTML(
            "afterend",
            '<p class="mc-cn-price">' +
              (info.qty > 1 ? info.qty + " × " : "") +
              esc(info.price) +
              "</p>",
          );
      } catch (e) {}
      try {
        d.dispatchEvent(new CustomEvent("mc:added"));
      } catch (e) {}
    };
    h.fail = function (err) {
      if (OA !== h) return;
      OA = null;
      restore();
      box.classList.remove("mc-lad-pend");
      if (bub && b0 !== null && bub.isConnected) bub.textContent = b0;
      if (info && info.keep) {
        if (head)
          head.textContent =
            T("Ürün eklenemedi", "Could not add the item") +
            (err && err.description ? ": " + err.description : "");
        if (prod) prod.innerHTML = "";
      } else {
        try {
          cn.close();
        } catch (e) {}
      }
      (w.mcCartGet
        ? w.mcCartGet(true)
        : fetch(U("/cart.js"), {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          }).then(function (r) {
            return r.json();
          })
      )
        .then(function (c) {
          var x = d.querySelector(
            "#cart-icon-bubble .cart-count-bubble span[aria-hidden]",
          );
          if (x && c && typeof c.item_count === "number")
            x.textContent = c.item_count;
        })
        .catch(function () {});
    };
    h.cancel = function () {
      if (OA === h) OA = null;
      restore();
    };
    OA = h;
    return h;
  }
  function priceTxt(el) {
    return el
      ? el.textContent
          .replace(/[·\s]+/g, " ")
          .replace(/^\s*Sepete ekle\s*/i, "")
          .trim()
      : "";
  }
  function cardInfo(f, qty) {
    var c =
      f.closest(".mc-card") ||
      f.closest('[class*="mc-rev"]') ||
      f.parentElement;
    if (!c) return null;
    var im = c.querySelector("img"),
      t = c.querySelector('.mc-card__title,[class*="__name"],h3,h4');
    return {
      title: t ? t.textContent.trim() : "",
      img: im ? im.currentSrc || im.src : "",
      price: priceTxt(
        c.querySelector(".mc-card__bp") || c.querySelector(".mc-card__price"),
      ),
      qty: qty || 1,
    };
  }
  function pdpInfo(f) {
    var fid = f.getAttribute("id"),
      q =
        (fid &&
          d.querySelector('input[name="quantity"][form="' + fid + '"]')) ||
        f.querySelector('[name="quantity"]');
    var t =
      d.querySelector(".product__title h1") ||
      d.querySelector(".product__title") ||
      d.querySelector("h1");
    var im =
      d.querySelector(".product__media-item.is-active img") ||
      d.querySelector(".product__media img") ||
      d.querySelector(".product__media-list img");
    var pr = [].slice
      .call(
        d.querySelectorAll(
          ".product__info-container .price__sale .price-item--sale,.product__info-container .price-item--regular",
        ),
      )
      .filter(function (e) {
        return e.offsetParent;
      })[0];
    return {
      title: t ? t.textContent.trim() : "",
      img: im ? im.currentSrc || im.src : "",
      price: pr ? pr.textContent.trim() : "",
      qty: Math.max(1, parseInt(q && q.value, 10) || 1),
    };
  }
  /* ürün sayfası (Dawn product-form): Dawn'ın kendi isteğine dokunmadan sadece anında geri bildirim */
  d.addEventListener(
    "submit",
    function (e) {
      var f = e.target;
      if (!f || !f.closest) return;
      var pf = f.closest("product-form");
      if (!pf || f.matches(".mc-card__form,.mc-rev__form")) return;
      var b = f.querySelector('[name="add"]');
      if (!b || b.disabled || b.getAttribute("aria-disabled") === "true")
        return;
      if (!d.querySelector("cart-notification")) return;
      optimisticAdd(pdpInfo(f));
    },
    true,
  );

  /* ---------- AJAX sepete ekle (kartlar, yorumlar, rutinler) ---------- */
  function notify(res) {
    var cn = d.querySelector("cart-notification");
    if (cn && typeof cn.renderContents === "function" && res && res.sections) {
      try {
        var st = res.items
          ? Object.assign({}, res.items[0], { sections: res.sections })
          : res;
        cn.renderContents(st);
        return true;
      } catch (e) {}
    }
    return false;
  }
  function addItems(items, code, info) {
    var oa = optimisticAdd(info || null);
    var cn = d.querySelector("cart-notification");
    var body = { items: items };
    if (cn) {
      body.sections = [
        "cart-notification-product",
        "cart-notification-button",
        "cart-icon-bubble",
      ];
      body.sections_url = location.pathname;
    }
    var p = code
      ? fetch(U("/discount/" + encodeURIComponent(code)), {
          credentials: "same-origin",
          redirect: "manual",
        }).catch(function () {})
      : Promise.resolve();
    return p
      .then(function () {
        return fetch(U("/cart/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        });
      })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw j;
          return j;
        });
      })
      .then(
        function (j) {
          if (!notify(j)) {
            oa && oa.done();
            var b = d.querySelector("#cart-icon-bubble");
            if (!b) location.href = U("/cart");
          }
          d.dispatchEvent(new CustomEvent("cart:refresh"));
          return j;
        },
        function (err) {
          oa && oa.fail(err);
          throw err;
        },
      );
  }
  var KK = w.MC_KAMPANYA || {},
    GF = (w.MC_PLUS && w.MC_PLUS.gift) || {
      id: 51089419239739,
      at: KK.gift || 1000,
    };
  function tlK(n) {
    return (
      Math.round(n).toLocaleString(T("tr-TR", "en-US")) + " TL"
    );
  }
  function giftCombo(ids, b) {
    try {
      var c = w.mcCartLast && w.mcCartLast();
      if (!c || !c.items || c.item_count !== 0) return null;
      if (sessionStorage.getItem("mcGiftOff") === "1") return null;
      var av = JSON.parse(sessionStorage.getItem("mcGiftAv") || "null");
      if (!av || !av.a || Date.now() - av.t > 6e5) return null;
      var art = b.closest("article"),
        st = art && art.querySelector(".mc-rt__sum strong"),
        sum = st
          ? parseFloat(st.textContent.replace(/[^0-9,]/g, "").replace(",", "."))
          : 0;
      if (!(sum >= GF.at)) return null;
      var KV = KK.b3v || [];
      if (
        ids.some(function (i) {
          return KV.indexOf(+i) > -1;
        })
      )
        return null;
      if (art && art.querySelectorAll(".mc-rt__deal").length > 2) return null;
      var m = {};
      ids.forEach(function (i) {
        m[i] = (m[i] || 0) + 1;
      });
      var sig = Object.keys(m)
        .sort()
        .map(function (k) {
          return k + ":" + m[k];
        })
        .join("|");
      if (sessionStorage.getItem("mcGiftBlk2") === sig) return null;
      return { id: GF.id, quantity: 1, properties: { _hediye: "1" } };
    } catch (e) {
      return null;
    }
  }
  if (d.querySelector("[data-mc-addall]")) {
    (
      w.requestIdleCallback ||
      function (f) {
        setTimeout(f, 2500);
      }
    )(
      function () {
        try {
          var a = JSON.parse(sessionStorage.getItem("mcGiftAv") || "null");
          if (a && Date.now() - a.t < 6e5) return;
        } catch (e) {}
        fetch(U("/variants/" + GF.id + ".js"), {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (v) {
            if (v)
              try {
                sessionStorage.setItem(
                  "mcGiftAv",
                  JSON.stringify({ a: !!v.available, t: Date.now() }),
                );
              } catch (e) {}
          })
          .catch(function () {});
      },
      { timeout: 5000 },
    );
  }
  function flash(btn, ok, msg) {
    if (!btn) return;
    var html = btn.__mcH0 != null ? btn.__mcH0 : (btn.__mcH0 = btn.innerHTML);
    clearTimeout(btn.__mcT);
    btn.classList.remove("is-busy", "is-added", "is-err");
    btn.classList.add(ok ? "is-added" : "is-err");
    btn.innerHTML = msg;
    btn.__mcT = setTimeout(function () {
      btn.classList.remove("is-added", "is-err");
      btn.innerHTML = html;
      btn.__mcH0 = null;
    }, 2200);
  }
  d.addEventListener(
    "submit",
    function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches(".mc-card__form,.mc-rev__form"))
        return;
      var id = f.querySelector('[name="id"]');
      if (!id) return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"]');
      flash(btn, true, T("Eklendi ✓", "Added ✓"));
      addItems([{ id: +id.value, quantity: 1 }], null, cardInfo(f, 1)).catch(
        function (err) {
          flash(
            btn,
            false,
            (err && err.description) || T("Eklenemedi", "Could not add"),
          );
        },
      );
    },
    true,
  );
  d.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-mc-addall]");
    if (!b) return;
    e.preventDefault();
    var ids = (b.dataset.mcAddall || "").split(",").filter(Boolean);
    if (!ids.length) return;
    b.classList.add("is-busy");
    flash(b, true, T("Rutin sepette ✓", "Routine added ✓"));
    var gi = giftCombo(ids, b),
      rt =
        ids.length >= 3
          ? (
              ((b.closest("article") || d).querySelector("h3") || {})
                .textContent || "Rutin"
            )
              .trim()
              .slice(0, 60) +
            "|" +
            ids
              .filter(function (x, j) {
                return ids.indexOf(x) === j;
              })
              .join(",")
          : "";
    addItems(
      ids
        .map(function (i) {
          return rt
            ? { id: +i, quantity: 1, properties: { _rutin: rt } }
            : { id: +i, quantity: 1 };
        })
        .concat(gi ? [gi] : []),
      b.dataset.mcCode,
      {
        title:
          T("Rutin seti", "Routine set") +
          " (" +
          ids.length +
          " " +
          T("ürün", "items") +
          ")",
        img: ((b.closest("article") || d).querySelector("img") || {}).src || "",
        price: "",
        qty: ids.length,
      },
    ).catch(function (err) {
      flash(
        b,
        false,
        (err && err.description) || T("Eklenemedi", "Could not add"),
      );
    });
  });

  /* ---------- Ana slider: yanlarda önceki/sonraki slayt (peek) ---------- */
  function initPeek() {
    var mq = w.matchMedia("(min-width:1700px)"),
      G = 16;
    d.querySelectorAll('[id$="__bn_hero"] .mcbn').forEach(function (root) {
      if (root.dataset.peek) return;
      root.dataset.peek = 1;
      var tr = root.querySelector(".mcbn__track");
      if (!tr) return;
      var sl = [].slice.call(tr.children),
        n = sl.length;
      if (n < 2) return;
      function src(i) {
        var im = sl[((i % n) + n) % n].querySelector("img");
        if (!im) return "";
        return (im.getAttribute("src") || "").replace(
          /width=\d+/,
          "width=1600",
        );
      }
      function mk(cls, arrow, lbl) {
        var g = d.createElement("div");
        g.className = "mc-peek " + cls;
        g.setAttribute("role", "button");
        g.setAttribute("aria-label", lbl);
        var st = d.createElement("div");
        st.className = "mc-peek__s";
        for (var k = -1; k <= n; k++) {
          var it = d.createElement("div");
          it.className = "mc-peek__i";
          it.style.backgroundImage = 'url("' + src(k) + '")';
          it.dataset.k = k;
          st.appendChild(it);
        }
        g.appendChild(st);
        var sp = d.createElement("span");
        sp.setAttribute("aria-hidden", "true");
        sp.textContent = arrow;
        g.appendChild(sp);
        root.appendChild(g);
        return { el: g, st: st, items: [].slice.call(st.children) };
      }
      var L = mk("mc-peek--l", "‹", T("Önceki kampanya", "Previous")),
        Rr = mk("mc-peek--r", "›", T("Sonraki kampanya", "Next"));
      var W = 0,
        gw = 0,
        on = false,
        raf = 0;
      function sync() {
        raf = 0;
        if (!on) return;
        var s = tr.scrollLeft / Math.max(1, W),
          P = W + G;
        L.st.style.transform =
          "translate3d(" + (gw + G - (s + 1) * P) + "px,0,0)";
        Rr.st.style.transform = "translate3d(" + -(s + 2) * P + "px,0,0)";
      }
      function lay() {
        on = mq.matches;
        if (!on) return;
        var r = root.getBoundingClientRect();
        gw = Math.floor(r.left - 22);
        W = tr.clientWidth;
        if (gw < 110 || !W) {
          on = false;
          L.el.style.display = Rr.el.style.display = "none";
          return;
        }
        L.el.style.display = Rr.el.style.display = "";
        var h = tr.offsetHeight;
        [L, Rr].forEach(function (x) {
          x.el.style.width = gw + "px";
          x.el.style.height = h + "px";
          x.el.style.top = tr.offsetTop + "px";
          x.items.forEach(function (it) {
            it.style.width = W + "px";
            it.style.left = (+it.dataset.k + 1) * (W + G) + "px";
          });
        });
        L.el.style.left = -(gw + G) + "px";
        Rr.el.style.right = -(gw + G) + "px";
        sync();
      }
      function nav(dir) {
        var b = root.querySelector(dir < 0 ? ".mcbn__nav--p" : ".mcbn__nav--n");
        if (b) b.click();
        else {
          var i = Math.round(tr.scrollLeft / Math.max(1, W)) + dir;
          tr.scrollTo({ left: ((i + n) % n) * W, behavior: "smooth" });
        }
      }
      L.el.addEventListener("click", function () {
        nav(-1);
      });
      Rr.el.addEventListener("click", function () {
        nav(1);
      });
      tr.addEventListener(
        "scroll",
        function () {
          if (!raf) raf = requestAnimationFrame(sync);
        },
        { passive: true },
      );
      w.addEventListener("resize", function () {
        requestAnimationFrame(lay);
      });
      mq.addEventListener && mq.addEventListener("change", lay);
      lay();
      setTimeout(lay, 600);
    });
  }

  /* ---------- Kenardan kenara banner zeminleri (kaydırmayla birebir senkron) ---------- */
  var cvs = d.createElement("canvas"),
    ctx = cvs.getContext && cvs.getContext("2d", { willReadFrequently: true });
  function edges(img) {
    try {
      var W = 48,
        H = 48;
      cvs.width = W;
      cvs.height = H;
      ctx.clearRect(0, 0, W, H);
      ctx.drawImage(img, 0, 0, W, H);
      function avg(x) {
        var data = ctx.getImageData(x, 6, 3, H - 12).data,
          r = 0,
          g = 0,
          b = 0,
          c = 0;
        for (var i = 0; i < data.length; i += 4) {
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          c++;
        }
        return [r / c, g / c, b / c];
      }
      return [avg(0), avg(W - 3)];
    } catch (e) {
      return null;
    }
  }
  function initAmb() {
    var mq = w.matchMedia("(min-width:1700px)");
    ["strip_bn", "promo2_bn", "ap_edit"].forEach(function (k) {
      var sec = d.querySelector('[id$="__' + k + '"]');
      if (!sec || sec.dataset.amb) return;
      sec.dataset.amb = 1;
      var tr = sec.querySelector(".mcbn__track");
      if (!tr) return;
      sec.classList.add("mc-amb");
      var sl = [].slice.call(tr.children),
        n = sl.length,
        C = new Array(n),
        raf = 0;
      sl.forEach(function (s, i) {
        var im = s.querySelector("img");
        if (!im) return;
        var x = new Image();
        x.decoding = "async";
        x.onload = function () {
          C[i] = edges(x);
          sync();
        };
        x.src = (im.getAttribute("src") || "").replace(
          /width=\d+/,
          "width=200",
        );
      });
      function rgb(a) {
        return (
          "rgb(" +
          Math.round(a[0]) +
          "," +
          Math.round(a[1]) +
          "," +
          Math.round(a[2]) +
          ")"
        );
      }
      function mix(a, b, f) {
        return [
          a[0] + (b[0] - a[0]) * f,
          a[1] + (b[1] - a[1]) * f,
          a[2] + (b[2] - a[2]) * f,
        ];
      }
      function sync() {
        raf = 0;
        if (!mq.matches) return;
        var W = Math.max(1, tr.clientWidth),
          s = tr.scrollLeft / W,
          i = Math.floor(s),
          f = s - i;
        i = Math.max(0, Math.min(n - 1, i));
        var j = Math.min(n - 1, i + 1),
          a = C[i],
          b = C[j] || a;
        if (!a) return;
        sec.style.setProperty("--amb-l", rgb(mix(a[0], b[0], f)));
        sec.style.setProperty("--amb-r", rgb(mix(a[1], b[1], f)));
        sec.classList.add("is-amb");
      }
      function lay() {
        if (!mq.matches) return;
        var sr = sec.getBoundingClientRect(),
          t2 = tr.getBoundingClientRect();
        sec.style.setProperty("--amb-t", t2.top - sr.top + 18 + "px");
        sec.style.setProperty("--amb-h", Math.max(0, t2.height - 36) + "px");
        sync();
      }
      tr.addEventListener(
        "scroll",
        function () {
          if (!raf) raf = requestAnimationFrame(sync);
        },
        { passive: true },
      );
      w.addEventListener("resize", function () {
        requestAnimationFrame(lay);
      });
      lay();
      setTimeout(lay, 800);
    });
  }

  /* ---------- Bugünün Fırsatları çekmecesi ---------- */
  var OFFERS = 4;
  function initOffers() {
    if (d.getElementById("mc-of") || /^\/(checkouts|account)/.test(path))
      return;
    var el = d.createElement("div");
    el.id = "mc-of";
    el.className = "mc-of";
    el.innerHTML =
      '<div class="mc-of__panel" role="dialog" aria-label="' +
      T("Bugünün fırsatları", "Today’s offers") +
      '">' +
      '<div class="mc-of__hd"><b>' +
      T("Bugünün Fırsatları", "Today’s Offers") +
      '</b><button type="button" data-of-x aria-label="' +
      T("Kapat", "Close") +
      '">✕</button></div>' +
      '<div class="mc-of__it"><span class="mc-of__ic" style="background:#C94E0E">%</span><div class="mc-of__tx"><strong>' +
      T("İlk siparişine %15 indirim", "15% off your first order") +
      "</strong><small>" +
      T(
        /* 2026-10-21: ödeme adımına yönlendirir; eski: Kodu sepette gir, anında düşsün. / Enter the code in your cart. */ "Kodu kopyala, ödeme adımında “İndirim kodu” alanına yapıştır.",
        "Copy the code and paste it into the “Discount code” field at checkout.",
      ) +
      '</small><button type="button" class="mc-of__code" data-of-copy="ILK15">ILK15 <span>' +
      T("kopyala", "copy") +
      "</span></button></div></div>" +
      '<a class="mc-of__it" href="' +
      U("/collections/3-al-2-ode") +
      '"><span class="mc-of__ic mc-of__ic--s" style="background:#C8322B">3=2</span><div class="mc-of__tx"><strong>' +
      T("3 Al 2 Öde", "Buy 3 Pay 2") +
      "</strong><small>" +
      T(
        "Kampanyalı ürünlerde 3 al, 1 tanesi bedava.",
        "Pick 3 selected items, 1 is free.",
      ) +
      "</small></div></a>" +
      '<div class="mc-of__it"><span class="mc-of__ic" style="background:#1F7A5C">🎁</span><div class="mc-of__tx"><strong>' +
      T(
        "Kampanya dışı " + tlK(GF.at) + "'ye hediye maske",
        "Free mask with " + tlK(GF.at) + " of non-deal items",
      ) +
      "</strong><small data-of-gift>" +
      T("Sepet tutarına göre otomatik eklenir.", "Added automatically.") +
      '</small><div class="mc-of__bar"><i data-of-gbar style="width:0"></i></div></div></div>' +
      '<div class="mc-of__it"><span class="mc-of__ic" style="background:#2E6B55">🚚</span><div class="mc-of__tx"><strong>' +
      T(
        tlK(KK.ship || 1500) + " üzeri kargo bedava",
        "Free shipping over " + tlK(KK.ship || 1500),
      ) +
      "</strong><small data-of-ship>" +
      T(
        "Sepetin büyüdükçe: " +
          tlK(KK.t10 || 2000) +
          " üzeri %" +
          (KK.p10 || 10) +
          ", " +
          tlK(KK.t15 || 3500) +
          " üzeri %" +
          (KK.p15 || 15) +
          " indirim; 3 Al 2 Öde ile birleşir.",
        "Bigger cart: " +
          (KK.p10 || 10) +
          "% off over " +
          tlK(KK.t10 || 2000) +
          ", " +
          (KK.p15 || 15) +
          "% over " +
          tlK(KK.t15 || 3500) +
          "; combines with Buy 3 Pay 2.",
      ) +
      '</small><div class="mc-of__bar"><i data-of-sbar style="width:0"></i></div></div></div>' +
      '<a class="mc-of__it" href="' +
      U("/pages/modalco-club") +
      '" data-of-club><span class="mc-of__ic" style="background:#1F4A3B"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/><path d="M5 21h14"/></svg></span><div class="mc-of__tx"><strong>Modalco Club</strong><small>' +
      T(
        "Üye ol, puan topla, özel fırsatları ilk sen gör.",
        "Join, earn points, get early access.",
      ) +
      "</small></div></a>" +
      '<p class="mc-of__note">' +
      T(
        "3 Al 2 Öde her siparişte 1 kez geçerlidir ve sepet indirimiyle birleşir; kampanyadaki ürünler hediye maske eşiğine sayılmaz.",
        "Buy 3 Pay 2 applies once per order and combines with the cart discount; deal items don't count toward the free-mask threshold.",
      ) +
      "</p>" +
      "</div>" +
      '<div class="mc-of__row">' +
      '<button type="button" class="mc-of__club" data-of-clubbtn aria-label="Modalco Club"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/><path d="M5 21h14"/></svg><span>Modalco Club</span></button>' +
      '<button type="button" class="mc-of__btn" aria-expanded="false" aria-controls="mc-of"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg><span class="mc-of__t"><span class="mc-of__lbl-l">' +
      T("Bugünün ", "Today’s ") +
      "</span>" +
      T("Fırsatlar", "Offers") +
      '<span class="mc-of__lbl-l">' +
      T("ı", "") +
      "</span></span> <i>" +
      OFFERS +
      "</i></button>" +
      "</div>";
    d.body.appendChild(el);
    var btn = el.querySelector(".mc-of__btn");
    function cart() {
      (w.mcCartGet
        ? w.mcCartGet()
        : fetch(U("/cart.js"), {
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          }).then(function (r) {
            return r.json();
          })
      )
        .then(function (c) {
          /* aynı kurallar sepetteki ödül çubuğuyla (modalco-plus) ortak hesaplanır */
          var I = w.mcLadderInfo ? w.mcLadderInfo(c) : null,
            t = Math.round((I ? I.base : (c.total_price || 0) / 100) * 100),
            gt = Math.round((I && I.gb != null ? I.gb : t / 100) * 100),
            ga = Math.round(GF.at * 100),
            sa = Math.round((I ? I.shipAt : KK.ship || 1500) * 100),
            g = el.querySelector("[data-of-gift]"),
            s = el.querySelector("[data-of-ship]");
          var t10 = Math.round((I ? I.t10 : KK.t10 || 2000) * 100);
          el.querySelector("[data-of-gbar]").style.width =
            Math.min(100, (gt / ga) * 100) + "%";
          var sn =
              I && I.shipNeed != null
                ? Math.round(I.shipNeed * 100)
                : Math.max(0, sa - t),
            tn = t;
          el.querySelector("[data-of-sbar]").style.width =
            Math.min(100, sn <= 0 ? 100 : (tn / sa) * 100) + "%";
          if (I ? I.gf : gt >= ga)
            g.innerHTML =
              '<span class="mc-of__ok">' +
              T("Hediye maske hakkın açıldı ✓", "Free mask unlocked ✓") +
              "</span>";
          else if (gt >= ga)
            g.textContent = T(
              "Hediye maske sepette otomatik eklenir.",
              "The free mask is added in your cart.",
            );
          else if (t > 0)
            g.textContent = T(
              "Hediye maskeye " +
                money(ga - gt) +
                " kaldı" +
                (gt < t ? " (3 Al 2 Öde ürünleri hariç)." : "."),
              money(ga - gt) +
                " to go for the free mask" +
                (gt < t ? " (Buy 3 Pay 2 items excluded)." : "."),
            );
          else
            g.textContent = T(
              "Kampanya dışı ürünlerde " + tlK(GF.at) + "'ye hediye maske.",
              "Free mask with " + tlK(GF.at) + " of non-deal items.",
            );
          var tierTxt =
            I && I.tier
              ? ""
              : I && I.off && I.off["%10"]
                ? ""
                : t < t10
                  ? T(
                      " · %10 indirime " + money(t10 - t),
                      " · " + money(t10 - t) + " to 10% off",
                    )
                  : "";
          if (sn <= 0)
            s.innerHTML =
              '<span class="mc-of__ok">' +
              T("Kargo bedava ✓", "Free shipping ✓") +
              "</span>" +
              tierTxt;
          else if (t > 0)
            s.textContent = T(
              "Ücretsiz kargoya " + money(sn) + " kaldı.",
              money(sn) + " to free shipping.",
            );
        })
        .catch(function () {});
    }
    function open(o) {
      el.classList.toggle("is-open", o);
      btn.setAttribute("aria-expanded", o ? "true" : "false");
      if (o) {
        cart();
        if (w.gtag) {
          try {
            gtag("event", "view_promotion", {
              promotion_name: "offers_drawer",
            });
          } catch (e) {}
        }
      }
    }
    btn.addEventListener("click", function () {
      open(!el.classList.contains("is-open"));
    });
    el.querySelector("[data-of-x]").addEventListener("click", function () {
      open(false);
    });
    d.addEventListener("click", function (e) {
      if (el.classList.contains("is-open") && !el.contains(e.target))
        open(false);
    });
    d.addEventListener("keydown", function (e) {
      if (e.key === "Escape") open(false);
    });
    el.querySelector("[data-of-copy]").addEventListener("click", function (e) {
      var b = e.currentTarget;
      try {
        navigator.clipboard.writeText("ILK15");
      } catch (x) {}
      b.querySelector("span").textContent = T("kopyalandı ✓", "copied ✓");
    });
    /* Modalco Club: kendi butonumuz anında görünür, Joy (Avada) paneli arka planda açılır */
    function joyBtn() {
      var b =
        d.querySelector("#Avada-Joy_FloatingButton .joy-fab-pure") ||
        d.querySelector("#Avada-Joy_FloatingButton button");
      if (b) return b;
      var x = d.querySelector("joy-loyalty-widget"),
        f = x && x.shadowRoot && x.shadowRoot.querySelector("joy-fab-button");
      if (f) return (f.shadowRoot && f.shadowRoot.querySelector("button")) || f;
      return null;
    }
    function openClub(e) {
      if (e) e.preventDefault();
      open(false);
      var cid =
        (w.__st && w.__st.cid) ||
        (w.ShopifyAnalytics &&
          w.ShopifyAnalytics.meta &&
          w.ShopifyAnalytics.meta.page &&
          w.ShopifyAnalytics.meta.page.customerId) ||
        (w.joyInstance && w.joyInstance.customer && w.joyInstance.customer.id);
      if (!cid) {
        if (/\/pages\/modalco-club\/?$/.test(location.pathname)) {
          w.scrollTo({ top: 0, behavior: "smooth" });
          return;
        }
        location.href = U("/pages/modalco-club");
        return;
      }
      var t0 = Date.now();
      (function tryOpen() {
        if (typeof w.avadaJoyTrigger === "function") {
          w.avadaJoyTrigger();
          return;
        }
        var j = joyBtn();
        if (j) {
          j.click();
          return;
        }
        if (Date.now() - t0 < 3000) setTimeout(tryOpen, 200);
        else location.href = U("/pages/modalco-club");
      })();
    }
    el.querySelector("[data-of-clubbtn]").addEventListener("click", openClub);
    var ca = el.querySelector("[data-of-club]");
    ca && ca.addEventListener("click", openClub);
    d.addEventListener("cart:refresh", function () {
      el.classList.contains("is-open") && cart();
    });
  }

  /* ---------- Cilt testi kenar kartı ---------- */
  function initQuiz() {
    if (
      d.getElementById("mc-qz") ||
      /cilt-tipini-bul|^\/cart|^\/checkouts|^\/account/.test(path)
    )
      return;
    var until = +(ls("mcQzHide") || 0);
    if (Date.now() < until) return;
    var q = U("/pages/cilt-tipini-bul");
    var el = d.createElement("div");
    el.id = "mc-qz";
    el.className = "mc-qz";
    el.innerHTML =
      '<button type="button" class="mc-qz__tab" aria-expanded="false">' +
      T("Cilt tipini bul", "Find your skin type") +
      " <em>2 " +
      T("dk", "min") +
      "</em></button>" +
      '<div class="mc-qz__card"><div class="mc-qz__in"><button type="button" class="x" aria-label="' +
      T("Gizle", "Hide") +
      '">✕</button>' +
      '<div class="mc-eyebrow" style="font-size:11px">' +
      T("2 dakikalık test", "2-minute test") +
      "</div>" +
      "<h4>" +
      T("Cilt Tipini <b>Bul</b>", "Find Your <b>Skin Type</b>") +
      "</h4>" +
      "<p>" +
      T(
        "6 kısa soru; sabah-akşam rutinin ve ürün önerilerin hazır. Rutini tek tıkla sepete ekle, RUTIN10 ile %10 kazan.",
        "6 quick questions for your AM/PM routine. Add it in one click and save 10% with RUTIN10.",
      ) +
      "</p>" +
      '<div class="mc-qz__chips"><a href="' +
      q +
      '">' +
      T("Kuru", "Dry") +
      '</a><a href="' +
      q +
      '">' +
      T("Yağlı", "Oily") +
      '</a><a href="' +
      q +
      '">' +
      T("Karma", "Combo") +
      '</a><a href="' +
      q +
      '">' +
      T("Hassas", "Sensitive") +
      "</a></div>" +
      '<a class="mc-qz__go" href="' +
      q +
      '">' +
      T("TESTE BAŞLA", "START THE TEST") +
      ' →</a><div class="mc-qz__fine">' +
      T("Ücretsiz · Üyelik gerekmez", "Free · No sign-up") +
      "</div></div></div>";
    d.body.appendChild(el);
    var tab = el.querySelector(".mc-qz__tab");
    function open(o) {
      el.classList.toggle("is-open", o);
      tab.setAttribute("aria-expanded", o ? "true" : "false");
    }
    tab.addEventListener("click", function () {
      open(!el.classList.contains("is-open"));
    });
    el.querySelector(".x").addEventListener("click", function () {
      open(false);
      el.remove();
      ls("mcQzHide", String(Date.now() + 3 * 864e5));
    });
    el.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        if (w.gtag) {
          try {
            gtag("event", "select_promotion", {
              promotion_name: "quiz_side_card",
            });
          } catch (e) {}
        }
      });
    });
  }

  /* ---------- Joy (Modalco Club) panel düzeltmeleri ----------
     - panel kapanınca Joy kendi "Modalco Club" butonunu gösteriyor; bizim butonla üst üste biniyordu -> gizle
     - önerilen/son görüntülenen ürün kartları görselleri 3:4 kutuda kırpıyordu -> 2:3 kutu, tam görsel */
  function initJoyFix() {
    if (!w.CSSStyleSheet || !("adoptedStyleSheets" in Document.prototype))
      return;
    var sh;
    try {
      sh = new CSSStyleSheet();
      sh.replaceSync(
        "joy-fab-button{display:none!important}" +
          ".joy-card-image-wrapper{aspect-ratio:2/3!important;height:auto!important;background:#fff!important;overflow:hidden!important}" +
          ".joy-card-image-wrapper img{width:100%!important;height:100%!important;max-height:none!important;object-fit:contain!important;object-position:center!important;transform:none!important}",
      );
    } catch (e) {
      return;
    }
    var seen = new WeakSet();
    function walk(r) {
      if (!seen.has(r)) {
        seen.add(r);
        try {
          r.adoptedStyleSheets = r.adoptedStyleSheets.concat([sh]);
        } catch (e) {}
      }
      var all = r.querySelectorAll("*");
      for (var i = 0; i < all.length; i++) {
        if (all[i].shadowRoot) {
          walk(all[i].shadowRoot);
          watch(all[i].shadowRoot);
        }
      }
    }
    /* eskiden her 600 ms'de tüm Joy gölge ağacı taranıyordu (sürekli CPU). Artık: widget bulunana kadar sınırlı
       deneme, sonra yalnızca Joy içeriği değiştiğinde (MutationObserver) ya da tıklamada yeniden uygulanır. */
    var wat = new WeakSet();
    function watch(r) {
      if (wat.has(r)) return;
      wat.add(r);
      try {
        new MutationObserver(function () {
          clearTimeout(r.__mcJ);
          r.__mcJ = setTimeout(function () {
            walk(r);
          }, 150);
        }).observe(r, { childList: true, subtree: true });
      } catch (e) {}
    }
    function tick() {
      var x = d.querySelector("joy-loyalty-widget");
      if (x && x.shadowRoot) {
        walk(x.shadowRoot);
        watch(x.shadowRoot);
        return true;
      }
      return false;
    }
    var tries = 0;
    (function poll() {
      if (tick() || ++tries > 50) return;
      setTimeout(poll, tries < 10 ? 600 : 1500);
    })();
    d.addEventListener(
      "click",
      function (e) {
        var p = e.composedPath ? e.composedPath() : [];
        if (
          p.some(function (n) {
            return n && n.tagName && /^JOY-/i.test(n.tagName);
          })
        )
          setTimeout(tick, 350);
      },
      true,
    );
  }

  /* ---------- Sepet ve ödeme düzeni v2 (ocoza yapısı) ----------
     Panel ve sepet sayfasında öneriler, sipariş özeti kartına ödeme ikonları + güven satırları.
     Sepet hesapları, hediye, ödül çubuğu ve ödeme koruması modalco-plus / modalco-cart'ta aynen kalır. */
  var GIFT_PID = null,
    GIFT_VID = 51089419239739; /* hediye maske: öneri olarak gösterilmez */
  function latestPid(c) {
    var it = (c.items || []).filter(function (i) {
      return !(i.properties && i.properties._hediye);
    })[0];
    if (c.items) {
      c.items.forEach(function (i) {
        if (i.properties && i.properties._hediye) GIFT_PID = i.product_id;
      });
    }
    return it ? it.product_id : null;
  }
  var recCache = {};
  function loadRecs(pid, intent) {
    var k = pid + "|" + intent;
    if (recCache[k]) return recCache[k];
    var p = fetch(
      U(
        "/recommendations/products.json?product_id=" +
          pid +
          "&limit=8&intent=" +
          intent,
      ),
      { credentials: "same-origin" },
    )
      .then(function (r) {
        if (!r.ok) throw r.status;
        return r.json();
      })
      .then(function (j) {
        return j.products || [];
      })
      .catch(function () {
        delete recCache[k];
        return [];
      });
    return (recCache[k] = p);
  }
  function recList(pid) {
    return loadRecs(pid, "complementary").then(function (l) {
      return l.length >= 4
        ? l
        : loadRecs(pid, "related").then(function (r) {
            return l.concat(r);
          });
    });
  }
  function rcCard(p) {
    var v = (p.variants || []).filter(function (x) {
        return x.available;
      })[0],
      img = p.featured_image || (p.images && p.images[0]) || "";
    if (img) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=400";
    var price = v ? v.price : p.price,
      cmp = v ? v.compare_at_price : p.compare_at_price,
      url = p.url || U("/products/" + p.handle),
      sale = cmp && cmp > price;
    var single = v && (p.variants || []).length === 1;
    return (
      '<div class="mc-rc"><a class="mc-rc__img" href="' +
      esc(url) +
      '" tabindex="-1" aria-hidden="true">' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") +
      (sale
        ? '<span class="mc-rc__badge">' + T("İndirim", "Sale") + "</span>"
        : "") +
      "</a>" +
      '<div class="mc-rc__vendor">' +
      esc(p.vendor || "") +
      '</div><a class="mc-rc__name" href="' +
      esc(url) +
      '">' +
      esc(p.title) +
      "</a>" +
      '<div class="mc-rc__price">' +
      money(price) +
      (sale
        ? '<span class="mc-rc__was"><span class="visually-hidden">' +
          T("Normal fiyat", "Regular price") +
          " </span>" +
          money(cmp) +
          "</span>"
        : "") +
      "</div>" +
      (single
        ? '<button type="button" class="mc-rc__add" data-mc-rc-add="' +
          v.id +
          '" data-mc-rc-title="' +
          esc(p.title) +
          '" data-mc-rc-img="' +
          esc(img) +
          '" data-mc-rc-price="' +
          esc(money(price)) +
          '" aria-label="' +
          esc(T("Sepete ekle: ", "Add to cart: ") + p.title) +
          '">+ ' +
          T("Sepete ekle", "Add to cart") +
          "</button>"
        : v
          ? '<a class="mc-rc__add" style="display:grid;place-items:center;text-decoration:none" href="' +
            esc(url) +
            '" aria-label="' +
            esc(T("Seçenekleri gör: ", "View options: ") + p.title) +
            '">' +
            T("Seçenekleri gör", "View options") +
            "</a>"
          : "") +
      "</div>"
    );
  }
  function getCart() {
    return w.mcCartGet
      ? w.mcCartGet()
      : fetch(U("/cart.js"), {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        }).then(function (r) {
          return r.json();
        });
  }
  /* pid verilirse öneriler hemen o ürüne göre yüklenir; sepet her durumda okunur (sepettekiler ve hediye önerilmez).
     Aynı liste tekrar gelirse DOM'a dokunulmaz (titreme olmaz); her alan kendi sırasını tutar (eski yanıt yenisini ezmez). */
  function fillRecs(el, limit, pid) {
    if (!el) return;
    var my = (el.__mcSeq = (el.__mcSeq || 0) + 1);
    var lc = pid && w.mcCartLast && w.mcCartLast(),
      cp = lc
        ? Promise.resolve(lc)
        : getCart().catch(function () {
            return null;
          });
    var pp = pid
      ? Promise.resolve(pid)
      : cp.then(function (c) {
          return c ? latestPid(c) : null;
        });
    Promise.all([pp, cp])
      .then(function (a) {
        var pid2 = a[0],
          c = a[1];
        if (my !== el.__mcSeq) return;
        if (!pid2) {
          el.innerHTML = "";
          el.__mcKey = "";
          return;
        }
        var inCart = {};
        if (c) {
          latestPid(c);
          (c.items || []).forEach(function (i) {
            inCart[i.product_id] = 1;
          });
        }
        return recList(pid2).then(function (list) {
          if (my !== el.__mcSeq) return;
          var seen = {};
          list = list
            .filter(function (p) {
              if (
                seen[p.id] ||
                inCart[p.id] ||
                p.id === GIFT_PID ||
                p.id === pid2 ||
                (p.variants || []).some(function (v) {
                  return v.id === GIFT_VID;
                })
              )
                return false;
              seen[p.id] = 1;
              return (p.variants || []).some(function (v) {
                return v.available;
              });
            })
            .slice(0, limit);
          var key = list
            .map(function (p) {
              return p.id;
            })
            .join(",");
          if (key === el.__mcKey && el.innerHTML) return;
          el.__mcKey = key;
          if (!list.length) {
            el.innerHTML = "";
            return;
          }
          el.innerHTML =
            '<p class="mc-recs__kicker">' +
            T("Rutinini tamamla", "Complete your routine") +
            '</p><h3 class="mc-recs__title">' +
            T("Birlikte iyi gider", "Goes well with") +
            '</h3><div class="mc-recs__grid">' +
            list.map(rcCard).join("") +
            "</div>";
        });
      })
      .catch(function () {
        if (my === el.__mcSeq) {
          el.innerHTML = "";
          el.__mcKey = "";
        }
      });
  }
  /* yalnızca ödeme sayfasında gerçekten sunulan yöntemlerin ikonları (cüzdanlar checkout'ta yok) */
  var PAY_HIDE = /apple|google|shop ?pay|paypal|amazon|meta|facebook|samsung/i;
  function payLabel(li) {
    var sv = li.querySelector("svg"),
      t =
        sv &&
        sv.getAttribute("aria-labelledby") &&
        d.getElementById(sv.getAttribute("aria-labelledby"));
    return (
      (t && t.textContent) ||
      (sv &&
        sv.querySelector("title") &&
        sv.querySelector("title").textContent) ||
      (li.querySelector("img") || {}).alt ||
      li.textContent ||
      ""
    ).trim();
  }
  function cleanPay(ul) {
    if (!ul) return;
    [].slice.call(ul.children).forEach(function (li) {
      if (PAY_HIDE.test(payLabel(li))) li.remove();
    });
  }
  function hdrSync() {
    var h = d.querySelector(".section-header");
    if (!h) return;
    var on =
      h.classList.contains("shopify-section-header-sticky") &&
      !h.classList.contains("shopify-section-header-hidden");
    var hh = (h.querySelector(".header-wrapper") || h).getBoundingClientRect()
      .height;
    root.style.setProperty("--mc-hh", Math.round(hh) + "px");
    root.classList.toggle("mc-hdr-on", on);
    root.classList.add("mc-hdr-js");
  }
  function initCartUX() {
    var box = d.getElementById("cart-notification");
    if (box && !box.querySelector(".mc-recs")) {
      var rec = d.createElement("div");
      rec.className = "mc-recs mc-recs--panel";
      box.appendChild(rec);
      var was = false;
      new MutationObserver(function () {
        var o = box.classList.contains("active");
        if (o !== was) {
          d.body.classList.toggle("mc-cart-open", o);
          if (o) {
            var m =
              w.ShopifyAnalytics &&
              ShopifyAnalytics.meta &&
              ShopifyAnalytics.meta.product;
            if (m && m.id) fillRecs(rec, 4, m.id);
            else if (!box.classList.contains("mc-oa")) fillRecs(rec, 4, null);
            else {
              rec.innerHTML = "";
              rec.__mcKey = "";
            }
          }
        }
        was = o;
      }).observe(box, { attributes: true, attributeFilter: ["class"] });
      d.addEventListener("mc:added", function () {
        if (box.classList.contains("active")) fillRecs(rec, 4, null);
      });
      /* odak panelin dışına kaysa da Esc paneli kapatsın */
      d.addEventListener("keydown", function (e) {
        if (
          (e.key === "Escape" || e.key === "Esc") &&
          box.classList.contains("active")
        ) {
          var cn = d.querySelector("cart-notification");
          try {
            cn && cn.close && cn.close();
          } catch (x) {}
        }
      });
    }
    if (/^\/cart\/?$/.test(path)) {
      var form = d.getElementById("cart"),
        ci = d.querySelector("cart-items");
      if (form && ci && !d.querySelector(".mc-cart-recs")) {
        var cr = d.createElement("div");
        cr.className = "mc-recs mc-cart-recs";
        /* öneriler sipariş özetinin ardından gelsin (mobilde özet önce); masaüstünde sol sütunda ürünlerin altında */
        var fsec = d.getElementById("main-cart-footer");
        fsec = fsec && fsec.closest(".shopify-section");
        if (fsec && fsec.parentNode) {
          var wr = d.createElement("div");
          wr.className = "mc-cart-recs-wrap page-width";
          wr.appendChild(cr);
          fsec.parentNode.insertBefore(wr, fsec.nextSibling);
        } else form.parentNode.insertBefore(cr, form.nextSibling);
        fillRecs(cr, 5, null);
        var last = d.querySelectorAll("#main-cart-items tr.mc-row").length + "";
        new MutationObserver(function () {
          var n = d.querySelectorAll("#main-cart-items tr.mc-row").length + "";
          if (n !== last) {
            last = n;
            if (!ci.classList.contains("is-empty")) fillRecs(cr, 5, null);
            else cr.innerHTML = "";
          }
        }).observe(d.getElementById("main-cart-items"), {
          childList: true,
          subtree: true,
        });
      }
      var ctas = d.querySelector("#main-cart-footer .cart__ctas");
      if (ctas && !d.querySelector(".mc-cart-extras")) {
        var ex = d.createElement("div");
        ex.className = "mc-cart-extras";
        var ul = d.querySelector(".mc-foot__pay ul");
        ex.innerHTML =
          (ul
            ? '<ul class="mc-cart-extras__pay" role="list" aria-label="' +
              T("Ödeme yöntemleri", "Payment methods") +
              '">' +
              ul.innerHTML +
              "</ul>"
            : "") +
          '<ul class="mc-cart-extras__trust"><li>' +
          T("Güvenli ödeme altyapısı", "Secure checkout") +
          "</li><li>" +
          T(
            "%100 orijinal, faturalı ürün",
            "100% original, invoiced products",
          ) +
          "</li><li>" +
          T(
            "Hafta içi 12:00'ye kadar verilen siparişler aynı gün kargoda",
            "Weekday orders placed by 12:00 (TR) ship the same day",
          ) +
          "</li><li>" +
          T(
            "Açılmamış ürünlerde 14 gün kolay iade",
            "14-day easy returns on unopened items",
          ) +
          "</li></ul>";
        ctas.parentNode.insertBefore(ex, ctas.nextSibling);
        cleanPay(ex.querySelector(".mc-cart-extras__pay"));
      }
      hdrSync();
      var hs = d.querySelector(".section-header");
      if (hs)
        new MutationObserver(hdrSync).observe(hs, {
          attributes: true,
          attributeFilter: ["class"],
        });
      w.addEventListener("resize", hdrSync, { passive: true });
    }
  }
  /* öneri kartından sepete ekleme: sepet sayfasında tek işlem kuyruğuyla, diğer sayfalarda anında geri bildirimli panelle */
  d.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-mc-rc-add]");
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains("is-busy")) return;
    var id = +b.getAttribute("data-mc-rc-add");
    b.classList.add("is-busy");
    var ok = function () {
      b.classList.remove("is-busy");
      b.classList.add("is-added");
      b.textContent = T("Eklendi ✓", "Added ✓");
      setTimeout(function () {
        b.classList.remove("is-added");
        b.textContent = "+ " + T("Sepete ekle", "Add to cart");
      }, 2000);
    };
    var bad = function (err) {
      b.classList.remove("is-busy");
      b.textContent =
        (err && err.description) || T("Eklenemedi", "Could not add");
      setTimeout(function () {
        b.textContent = "+ " + T("Sepete ekle", "Add to cart");
      }, 2500);
    };
    if (
      /^\/cart\/?$/.test(path) &&
      w.mcCartTx &&
      !b.closest("#cart-notification")
    ) {
      w.mcCartTx(function () {
        var sb = { items: [{ id: id, quantity: 1 }] };
        try {
          var ss = (w.mcCartSecs ? w.mcCartSecs() : []).concat("mc-cart-json");
          sb.sections = ss.join(",");
          sb.sections_url = location.pathname;
        } catch (x) {}
        return fetch(U("/cart/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(sb),
        }).then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw j;
            var c = w.mcSecCart && w.mcSecCart(j.sections);
            if (c && c.items) {
              c.sections = j.sections;
              return c;
            }
            return true;
          });
        });
      }).then(function () {
        ok();
      }, bad);
    } else {
      addItems([{ id: id, quantity: 1 }], null, {
        title: b.getAttribute("data-mc-rc-title"),
        img: b.getAttribute("data-mc-rc-img"),
        price: b.getAttribute("data-mc-rc-price"),
        qty: 1,
        keep: !!b.closest("#cart-notification"),
      }).then(ok, bad);
    }
  });

  function boot() {
    d.querySelectorAll(".mc-foot__pay ul").forEach(cleanPay);
    initPeek();
    initAmb();
    initOffers();
    initQuiz();
    initJoyFix();
    hookErr();
    initCartUX();
  }
  d.readyState !== "loading"
    ? boot()
    : d.addEventListener("DOMContentLoaded", boot);
  w.addEventListener("load", function () {
    initPeek();
    initAmb();
  });
})();

/* Modalco v6-4: mobil yüzen düğmeler aşağı kaydırırken gizlenir (CSS: html.mc-float-off) */
(function () {
  var d = document.documentElement,
    y = window.pageYOffset,
    t = 0;
  function f() {
    t = 0;
    var n = window.pageYOffset;
    if (n < 200 || n < y - 8) {
      d.classList.remove("mc-float-off");
    } else if (n > y + 8) {
      d.classList.add("mc-float-off");
    }
    if (Math.abs(n - y) > 8) y = n;
  }
  window.addEventListener(
    "scroll",
    function () {
      if (!t) {
        t = 1;
        requestAnimationFrame(f);
      }
    },
    { passive: true },
  );
})();
